export const FormErrors = {
  bindings: {
    field: '<',
    errors: '<',
  },

  template: `
    <div class="invalid-feedback d-flex px-2"
      ng-show="$ctrl.field.$touched && $ctrl.field.$invalid && $ctrl.errors"
      ng-messages="$ctrl.field.$error">
      <span
        ng-repeat="(key, value) in $ctrl.errors track by $index"
        ng-message="{{ key }}">
        {{ value }}
      </span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormErrors.js